import { EntityMapper } from "./entity-mapper.model";

export class Organization extends EntityMapper {

    id:string;
  
    name:string;
}